import React, { useRef, useEffect, useState } from 'react';

const VideoPlayer = ({ videoUrl, playbackRate }) => {
  const videoRef = useRef(null);
  const [error, setError] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = playbackRate;
    }
  }, [playbackRate]);

  const handleError = (e) => {
    console.error("Video error event:", e);
    console.error("Video error message:", e.target.error ? e.target.error.message : 'Unknown error');
    console.error("Video error code:", e.target.error ? e.target.error.code : 'No error code');
    setError(`Error loading video: ${e.target.error ? e.target.error.message : 'Unknown error'}`);
  };

  const handleCanPlay = () => {
    console.log("Video can play");
    setError(null);
    if (!isPlaying) {
      videoRef.current.play().then(() => setIsPlaying(true)).catch(handleError);
    }
  };

  const handleLoadedMetadata = () => {
    setDuration(videoRef.current.duration);
  };

  const handleTimeUpdate = () => {
    if (videoRef.current && videoRef.current.currentTime >= duration) {
      videoRef.current.currentTime = 0;
    }
  };

  return (
    <div className="video-player-container max-w-3xl mx-auto">
      {error && <div className="text-red-500">{error}</div>}
      {videoUrl ? (
        <video
          ref={videoRef}
          src={videoUrl}
          className="w-full"
          playsInline
          muted
          onError={handleError}
          onCanPlay={handleCanPlay}
          onLoadedMetadata={handleLoadedMetadata}
          onTimeUpdate={handleTimeUpdate}
        >
          Your browser does not support the video tag.
        </video>
      ) : (
        <div>Loading video...</div>
      )}
      <p className="mt-2 text-sm text-gray-600">video speed: {playbackRate}x</p>
    </div>
  );
};

export default VideoPlayer;